export default __webpack_public_path__ + "static/media/dummyImage1.067b3a48.png";